import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import DashboardHeader from './components/HeaderACV';
import StoricoContent from './components/StoricoContent';
import OrizonFooter from './components/OrizonFooter';
import Icon from '../../components/AppIcon';

const StoricoCCOPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <DashboardHeader />

      <main className="flex-grow w-full relative">
        {/* POVEĆAN PT (Padding Top): na mobile je sada pt-24 (bio je pt-16), na md ekranima pt-32 */}
        <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12 pt-24 md:pt-32 pb-12">
          
          {/* Navigacija nazad */}
          <div className="flex items-center gap-3 mb-8">
            <button 
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-muted/50 hover:bg-muted border border-border/50 transition-all group shadow-sm"
            >
              <Icon name="ArrowLeft" size={18} className="group-hover:-translate-x-1 transition-transform" />
              <span className="text-[10px] font-black uppercase tracking-widest">Indietro</span>
            </button>
          </div>

          {/* Glavni sadržaj tabele */}
          <StoricoContent />
        </div>
      </main>

      <OrizonFooter />
    </div>
  );
};

export default StoricoCCOPage;